import React, { Component } from 'react';
import Gravatar from 'react-gravatar';

import IconButton from 'material-ui/IconButton';
import Popover from 'material-ui/Popover';
import Menu from './Menu';

import Auth from '../../../helpers/auth';

class AccountPopMenu extends Component {

    constructor(props) {
        super(props);
        this.state = { open: false, anchorEl: undefined };
    }

    handleClick(event) {
        if (!this.state.open) {
            this.setState({ open: true, anchorEl: event.currentTarget });
        } else {
            const el = document.getElementById('accounts-widget-popover');
            el.style.display = 'block';
        }
    };

    handleRequestClose() {
        const el = document.getElementById('accounts-widget-popover');
        el.style.display = 'none';
    };

    render() {
        const user = Auth.getUserData() || {};

        return (
            <div>
                <IconButton color="inherit" onClick={this.handleClick.bind(this)}>
                    <Gravatar email={user.email || 'unknow@polibrasnet.com.br'} size={32} default="mm" className="avatar" />
                </IconButton>

                <Popover
                    id="accounts-widget-popover"
                    open={this.state.open}
                    anchorEl={this.state.anchorEl}
                    onRequestClose={this.handleRequestClose.bind(this)}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }} >

                    <Menu />

                </Popover>
            </div>
        );
    }
}

export default AccountPopMenu;




// WEBPACK FOOTER //
// ./src/psuite-js/components/mui/AccountPopMenu/index.js